<template>
  <div class="gtabs">
    <div
      ref="inner"
      class="gtabs_inner no-scroll-track"
      @mousedown="handleMousedown"
    >
      <div
        v-for="(item, idx) in options"
        :key="idx"
        :ref="`ref_${item[idKey] || item}`"
        class="gtabs_tab gw_hvr"
        :data-tst="`tab_${item.id || item[idKey] || item}`"
        :class="{
          gtabs_tab_active: value === (item[idKey] || item),
        }"
        :style="item.style || ''"
        v-bind="item.tour || {}"
        @click="onChange(item)"
      >
        <slot
          :item="item"
          :value="value"
        >
          {{ value }}
          {{ item }}
        </slot>
      </div>

      <slot name="inner_after"></slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'SimpleTabs',
  props: {
    options: Array,
    idKey: { default: 'id' },
    value: [String, Number, Object],
    scrollToActiveTab: Boolean,
    hasDragscroll: Boolean,
  },
  emits: ['input', 'click'],
  data() {
    return {
      mousedown: false,
      startX: 0,
      innerScrollLeft: 0,
    }
  },
  mounted() {
    if (this.scrollToActiveTab) {
      setTimeout(() => {
        this.scrollToTab(this.value)
      })
    }
  },
  beforeUnmount() {
    if (this.hasDragscroll) {
      this.removeEventListeners()
    }
  },
  methods: {
    onChange(item) {
      this.$emit('input', item[this.idKey] || item)
      this.$emit('click', item)
    },

    // scroll - best move this to horizontalScroll_mix and add wheelscroll as
    // but its good for now as it is - only one place
    removeEventListeners() {
      window.removeEventListener('mouseup', this.handleMouseup)
      window.removeEventListener('mousemove', this.handleMousemove)
    },
    handleMousedown(e) {
      // console.log('handleMousedown', e)
      if (!this.hasDragscroll) return
      const { inner } = this.$refs
      this.startX = e.pageX - inner.offsetLeft
      this.innerScrollLeft = inner.scrollLeft

      this.mousedown = true
      window.addEventListener('mouseup', this.handleMouseup)
      window.addEventListener('mousemove', this.handleMousemove, { passive: false })
    },
    handleMouseup() {
      this.mousedown = false
      this.removeEventListeners()
    },
    handleMousemove(e) {
      // console.log('mousemove', e)
      if (this.mousedown) {
        e.preventDefault()
        const { inner } = this.$refs
        const x = e.pageX - inner.offsetLeft
        const walk = (x - this.startX) * 1.5
        const scrollLeft = this.innerScrollLeft - walk
        inner.scrollLeft = scrollLeft
      }
    },
    // scroll mousedrag
    scrollToTab(id) {
      if (this.scrollToActiveTab && id) {
        nextTick(() => {
          setTimeout(() => {
            const tab = this.$refs[`ref_${id}`]
            if (tab?.[0]) {
              tab[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
            }
          }, 120)
        })
      }
    },
  },
  watch: {
    value(id) {
      this.scrollToTab(id)
    },
  },
}
</script>
<style lang="scss" scoped>
.tabs-column {
  .gtabs_inner {
    flex-direction: column;
  }
  .gtabs_tab {
    justify-content: flex-start;
  }
}

.gtabs {
  display: flex;
  position: relative;
  flex-shrink: 0;
  // background: var(--clr-black-0);
  z-index: 2;
  max-width: 100vw;

  // --tabs-overflow: hidden;
  --tabs-inner-overflow-y: hidden;
  --tabs-inner-overflow-x: auto;

  --height: unset;
  --height-inner: auto;
  --height-tab: 3rem;

  --min-width-tab: 4rem;
  --tab-radius: 4px;

  --padding-inner: 0;

  --padding-tab: 0 1rem;
  // --tab-letter-spacing: 1.25px;
  --tab-letter-spacing: 0px;
  --tab-fnt-size: 1rem;

  --clr-tab-back: transparent;
  --clr-tab-hover-back: var(--clr-black-1-3);
  --clr-tab-active-back: var(--clr-black-1-3);

  --tabs-underline-height: 2px;

  --tab-round-height: 0.5rem;

  --grid-gap: 0.25rem;
  // --tab-letter-spacing: 0.875px;
  // --tab-letter-spacing: 1px;
  // --tab-letter-spacing: 1.5px;
  // --tab-letter-spacing: 1.75px;

  --text-transform: none;
  // --text-transform: uppercase;
  // --text-transform: none;
  --font-weight: 500;
  --tab-justify-content: center;

  --clr-line: var(--clr-black-1-3);
  --clr-line-hover: var(--clr-primary);
  --clr-line-active: var(--clr-primary);

  --clr-text: var(--clr-white-0);
  --clr-hover-text: var(--clr-white-0);
  --clr-active-text: var(--clr-white-0);
  --inner-margin: 0;

  --tab-flex: 0 0 auto;
  --inner-flex: 0 0 auto;

  // overflow: var(--tabs-overflow);
  height: var(--height);
  min-width: 0;

  // &_simple {
  //   --tab-radius: 4px;
  //   --height: 1.875rem;
  //   --height-inner: 2.125rem;
  //   --height-tab: var(--height-inner);
  //   --tab-fnt-size: 0.875rem;
  //   --clr-hover-back: var(--clr-black-1);
  //   --clr-active-back: var(--clr-hover-back);
  //   --clr-line-active: var(--clr-hover-back);
  //   --tab-justify-content: space-between;
  //   --clr-line-hover: var(--clr-hover-back);
  //   --tabs-underline-height: 0;
  //   --clr-line: transparent;
  //   --clr-text: var(--clr-grey-2);
  //   --padding-tab: 0 1.25rem 0.125rem 1.25rem;
  //   --min-width-tab: 0rem;
  // }
  &_column {
    .gtabs_inner {
      flex-direction: column;
      flex: 1;
    }
    .gtabs_tab {
      justify-content: flex-start;
    }
  }
  &_simple_small_menu {
    // --height-tab: 1.75rem;
    --height-tab: 1.875rem;
    // --height-tab: 2rem;
    // --tab-fnt-size: 0.8rem;
    --tab-fnt-size: 0.875rem;
    // --padding-tab: 0 1rem;
    --padding-tab: 0 0.75rem;
    // --padding-tabs-wide: 0 1rem;
    --tab-radius: 0;
    --clr-line-hover: transparent;
    --clr-line-active: transparent;
    --grid-gap: 0rem;
    --clr-active-text: var(--clr-primary);
    --clr-line: transparent;
    // --tab-letter-spacing: 0.75px;
  }
  &_simple_small {
    --tab-radius: 6px;
    --height: 1.75rem;
    --height-inner: 2rem;
    --height-tab: var(--height-inner);
    // --tab-letter-spacing: 0.75px;

    // --tab-fnt-size: 0.8rem;
    --tab-fnt-size: 0.875rem;
    // --tab-fnt-size: 0.875rem;
    // --tab-fnt-size: 1rem;
    // --padding-tab: 0 1.25rem 0.125rem 1.25rem;
    --padding-tab: 0 1.125rem 0.125rem 1.125rem;
    // --padding-tab: 0 1rem 0.125rem 1rem;
    --padding-inner: 0 1rem 0 0;
    // --text-transform: none;
    // --padding-tab: 0 1.25rem 0.125rem 1.25rem;
    --clr-tab-hover-back: var(--clr-black-1);
    --clr-tab-active-back: var(--clr-tab-hover-back);

    --clr-line-active: var(--clr-tab-hover-back);

    --tab-justify-content: space-between;
    --clr-line-hover: var(--clr-tab-hover-back);
    --tabs-underline-height: 0;
    --clr-line: transparent;
    --clr-text: var(--clr-grey-2);
    --min-width-tab: 0rem;

    .gtabs_tab {
      // border-top: solid red 1px;
      // border-left: solid red 1px;
      // border-right: solid red 1px;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: calc(var(--tab-radius) * -1);
        height: var(--height);
        width: var(--tab-radius);
        // background: red;
        border-bottom-right-radius: var(--tab-radius);
        box-shadow: 0 var(--tab-round-height) 0 0 var(--clr-tab-back);
        // border-bottom: solid red 1px;
        // border-right: solid red 1px;
      }
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 100%;
        height: var(--height);
        width: var(--tab-radius);
        // background: blue;
        border-bottom-left-radius: var(--tab-radius);
        box-shadow: 0 var(--tab-round-height) 0 0 var(--clr-tab-back);
        // border-bottom: solid red 1px;
        // border-left: solid red 1px;
      }
    }
  }

  &:not(.gtabs_simple_small_menu, .gtabs_simple_small) {
    // --tab-radius: 4px;
    // --height: 1.875rem;
    --height-inner: var(--height);
    --height-tab: var(--height);
    // --height-tab: var(--height-inner);
    // --tab-fnt-size: 0.875rem;
    // --clr-hover-back: var(--clr-black-1);
    // --clr-active-back: var(--clr-hover-back);
    // --clr-line-active: var(--clr-hover-back);
    // --tab-justify-content: space-between;
    // --clr-line-hover: var(--clr-hover-back);
    // --tabs-underline-height: 0;
    // --clr-line: transparent;
    // --clr-text: var(--clr-grey-2);
    // --padding-tab: 0 1.25rem 0.125rem 1.25rem;
    // --min-width-tab: 0rem;
    .gtabs_tab {
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        // height: var(--height-line);
        height: 2px;
        background: var(--clr-line);
        transition: 0.22s;
        z-index: 3;
      }
    }
    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: var(--tabs-underline-height);
      background: var(--clr-line);
      z-index: 1;
    }
  }

  // &_simple_small {
  //   --tab-radius: 4px;
  //   --height: 1.5rem;
  //   --height-inner: 1.75rem;
  //   --height-tab: var(--height-inner);
  //   --tab-fnt-size: 0.7rem;
  //   --clr-hover-back: var(--clr-black-1);
  //   --clr-active-back: var(--clr-hover-back);
  //   --clr-line-active: var(--clr-hover-back);
  //   --tab-justify-content: space-between;
  //   --clr-line-hover: var(--clr-hover-back);
  //   --tabs-underline-height: 0;
  //   --clr-line: transparent;
  //   --clr-text: var(--clr-grey-2);
  //   --padding-tab: 0 0.875rem 0.25rem 0.875rem;
  //   --min-width-tab: 0rem;
  // }
  // height: var(--height);

  &_inner {
    position: relative;
    display: flex;
    flex: var(--inner-flex);
    flex-shrink: 0;
    min-width: 0;
    max-width: 100%;

    // width: 100%;
    height: var(--height-inner);
    grid-gap: var(--grid-gap);
    overflow-x: var(--tabs-inner-overflow-x);
    overflow-y: var(--tabs-inner-overflow-y);
    -webkit-overflow-scrolling: touch;
    padding: var(--padding-inner);
    margin: var(--inner-margin);
  }
  &_tab {
    position: relative;
    font-size: var(--tab-fnt-size);
    text-transform: var(--text-transform);
    color: var(--clr-text);
    padding: var(--padding-tab);
    height: var(--height-tab);
    flex: var(--tab-flex);
    // flex-shrink: 0;
    min-width: var(--min-width-tab);
    cursor: pointer;
    font-weight: var(--font-weight);
    letter-spacing: var(--tab-letter-spacing);
    background: var(--clr-tab-back);
    // line-height: 1.2;
    display: flex;
    align-items: center;
    justify-content: var(--tab-justify-content);
    white-space: nowrap;
    border-top-left-radius: var(--tab-radius);
    border-top-right-radius: var(--tab-radius);
    transition: 0.22s;
    // &:before {
    //   content: '';
    //   position: absolute;
    //   bottom: 0;
    //   left: 0;
    //   width: 100%;
    //   // height: var(--height-line);
    //   height: 2px;
    //   background: var(--clr-line);
    //   transition: 0.22s;
    //   z-index: 3;
    // }
    &_active {
      z-index: 4;
      color: var(--clr-active-text);
      --clr-tab-back: var(--clr-tab-active-back);
      --clr-line: var(--clr-line-active);
      // background: var(--clr-active-back);
      // &:before {
      //   background: var(--clr-line-active);
      // }
    }
  }
}

.tabs-stretch {
  width: 100%;
  .gtabs_inner {
    width: 100%;
  }
  .gtabs_tab {
    flex: 1;
  }
}
.tabs-wide {
  --padding-tabs-wide: 0 2rem;
  --padding-tabs-wide-mobile: 0 1.5rem;
  .gtabs_tab {
    --padding-tab: var(--padding-tabs-wide);
  }
}
@media (max-width: 1366px) {
  .tabs-wide {
    .gtabs_tab {
      --padding-tab: var(--padding-tabs-wide-mobile);
    }
  }
}

// ._12-to-left {
//   left: 0px !important;
// }

@media (hover: hover) and (pointer: fine) {
  .gtabs {
    &_tab {
      &:not(.gtabs_tab_active) {
        &:hover {
          color: var(--clr-hover-text);
          --clr-tab-back: var(--clr-tab-hover-back);
          --clr-line: var(--clr-line-hover);

          // &:before {
          //   background: var(--clr-line-hover);
          // }
        }
      }
    }
  }
}
</style>
